import React from 'react';
import { SocialNetwork } from '@actus/types';
import { SquareSvgProps } from '@icons/icon.types';
import { useTranslation } from '@locales/useTranslation.hook';

function XLogoIcon({ title, fillColor = '#2D3049', size = 28, ...props }: SquareSvgProps) {
  const { t } = useTranslation(['common']);
  return (
    <svg height={size} viewBox="0 0 31 28" width={size} xmlns="http://www.w3.org/2000/svg" {...props}>
      <title>{title || t('common.share', { socialNetworkName: SocialNetwork.X })}</title>
      <mask height="28" id="mask0_300_13806" maskUnits="userSpaceOnUse" width="31" x="0" y="0">
        <path d="M0 0H30.5455V28H0V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_300_13806)">
        <path
          d="M24.0545 1.31201H28.7389L18.5062 12.06L30.5455 26.688H21.12L13.7324 17.818L5.28873 26.688H0.6L11.544 15.188L0 1.31401H9.66545L16.3331 9.42001L24.0545 1.31201ZM22.4073 24.112H25.0036L8.24727 3.75401H5.46327L22.4073 24.112Z"
          fill={fillColor}
        />
      </g>
    </svg>
  );
}

export { XLogoIcon };
